/* eslint-disable no-restricted-imports */
import { StyledType, createComponent } from '@workday/canvas-kit-react/common';
import { PopupCloseButtonProps } from '@workday/canvas-kit-react/dist/es6/popup/lib/PopupCloseButton';
import { Modal } from '@workday/canvas-kit-react/modal';
import { createStencil, createStyles } from '@workday/canvas-kit-styling';
import { WcpCard } from '@workday/wcp-cargo-react';
import { WcpStyles } from '@workday/wcp-tokens';
import React, { Ref } from 'react';
import { ThemedSecondaryButton } from './ThemedSecondaryButton';

const themedModalCardStencil = createStencil({
  vars: {
    backgroundColor: WcpStyles.color.bg.default,
  },
  base: ({ backgroundColor }) => ({
    backgroundColor,
  }),
});

const ThemedModalCard: React.FC<React.ComponentProps<typeof Modal.Card & { backgroundColor?: string }>> = ({
  backgroundColor,
  ...props
}) => {
  return (
    <WcpCard
      as={Modal.Card}
      className='themed-modal-card'
      cs={themedModalCardStencil({ backgroundColor })}
      {...props}
    />
  );
};

const themedModalHeadingStyles = createStyles({
  color: WcpStyles.color.text.default,
});

const ThemedModalHeading: React.FC<React.ComponentProps<typeof Modal.Heading>> = (props) => {
  return <Modal.Heading className='themed-modal-heading' cs={themedModalHeadingStyles} {...props} />;
};

const ThemedModalCloseButton = createComponent(ThemedSecondaryButton)({
  Component: (props: PopupCloseButtonProps & StyledType, ref: Ref<HTMLButtonElement>, Element) => (
    <Modal.CloseButton ref={ref} as={Element} className='themed-modal-close-button' {...props} />
  ),
});

const themedModalBodyStyles = createStyles({
  color: WcpStyles.color.text.default,
});

const ThemedModalBody: React.FC<React.ComponentProps<typeof Modal.Body>> = ({ cs, ...props }) => {
  // Merge consumer `cs` with the themed body styles so passing `cs` doesn't drop the themed color.
  return <Modal.Body className='themed-modal-body' cs={[themedModalBodyStyles, cs]} {...props} />;
};

export const ThemedModal = (props: React.ComponentProps<typeof Modal>) => <Modal {...props} />;
ThemedModal.Body = ThemedModalBody;
ThemedModal.Card = ThemedModalCard;
ThemedModal.CloseButton = ThemedModalCloseButton;
ThemedModal.CloseIcon = Modal.CloseIcon;
ThemedModal.Heading = ThemedModalHeading;
ThemedModal.Overlay = Modal.Overlay;
ThemedModal.OverflowOverlay = Modal.OverflowOverlay;
ThemedModal.Target = Modal.Target;
